import { Column, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, VersionColumn } from "typeorm";
import { JobworkCreationEntity } from "./job-work-creation-entity";

export enum JobWorkStatus {
    PENDING = 'PENDING',
    ACCEPTED = 'ACCEPTED',
    REJECTED = 'REJECTED',
}
@Entity('price_negotiation')
export class PriceNegotiationEntity {

    @PrimaryGeneratedColumn('increment', {
        name: 'id'
    })
    id: number;

    @Column('varchar', {
        name: 'vendor',
        nullable: false
    })
    vendor: string;

    @Column('int', {
        name: 'shahi_price',
        nullable: false
    })
    shahiPrice: number;

    @Column('int', {
        name: 'vendor_price',
        nullable: false,
        default: 0
    })
    vendorPrice: number;

    @Column('int', {
        name: 'final_price',
        nullable: false,
        default: 0
    })
    finalPrice: number;

    @Column('boolean', {
        name: 'vendor_accepted',
        default: false,
        nullable: false
    })
    vendorAccepted: boolean;

    @Column('varchar', { default: JobWorkStatus.PENDING })
    jobWorkStatus: JobWorkStatus;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;

    @Column('int', {
        name: 'vendor_id',
        nullable: false,
        default: 0
    })
    vendorId: number;

    @ManyToOne(() => JobworkCreationEntity, (j) => j.price)
    @JoinColumn([{ name: 'jobwork_id' }])
    jobworkId: JobworkCreationEntity
}
